

function scrollToTargetAdjusted(element, offset = 96){
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - offset;
    window.scrollTo({
       top: offsetPosition,
       behavior: "smooth"
    });
}

(function () {
  const BAG_WEIGHT = 500;

  const FORMULA = [{"Weight":5,"Activity":0.03,"Age":1,"Grams per day":125,"Kilo 2 weeks":1.75,"Kilo per month":3.5,"Kilo 2 months":7.03},{"Weight":5,"Activity":0.0275,"Age":1,"Grams per day":125,"Kilo 2 weeks":1.75,"Kilo per month":3.5,"Kilo 2 months":7.03},{"Weight":5,"Activity":0.025,"Age":1,"Grams per day":125,"Kilo 2 weeks":1.75,"Kilo per month":3.5,"Kilo 2 months":7.03},{"Weight":5,"Activity":0.03,"Age":0.75,"Grams per day":125,"Kilo 2 weeks":1.75,"Kilo per month":3.5,"Kilo 2 months":7.03},{"Weight":5,"Activity":0.0275,"Age":0.75,"Grams per day":125,"Kilo 2 weeks":1.75,"Kilo per month":3.5,"Kilo 2 months":7.03},{"Weight":5,"Activity":0.025,"Age":0.75,"Grams per day":125,"Kilo 2 weeks":1.75,"Kilo per month":3.5,"Kilo 2 months":7.03},{"Weight":5,"Activity":0.03,"Age":0.5,"Grams per day":75,"Kilo 2 weeks":1.75,"Kilo per month":3.5,"Kilo 2 months":7.03},{"Weight":5,"Activity":0.0275,"Age":0.5,"Grams per day":75,"Kilo 2 weeks":1.75,"Kilo per month":3.5,"Kilo 2 months":7.03},{"Weight":5,"Activity":0.025,"Age":0.5,"Grams per day":75,"Kilo 2 weeks":1.75,"Kilo per month":3.5,"Kilo 2 months":7.03},{"Weight":6,"Activity":0.03,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.501,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":6,"Activity":0.0275,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.501,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":6,"Activity":0.025,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.501,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":6,"Activity":0.03,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.501,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":6,"Activity":0.0275,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.501,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":6,"Activity":0.025,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.501,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":6,"Activity":0.03,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":6,"Activity":0.0275,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":6,"Activity":0.025,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":7,"Activity":0.03,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":7,"Activity":0.0275,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":7,"Activity":0.025,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":7,"Activity":0.03,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":7,"Activity":0.0275,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":7,"Activity":0.025,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":7,"Activity":0.03,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":7,"Activity":0.0275,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":7,"Activity":0.025,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":8,"Activity":0.03,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":8,"Activity":0.0275,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":8,"Activity":0.025,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":8,"Activity":0.03,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":8,"Activity":0.0275,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":8,"Activity":0.025,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":8,"Activity":0.03,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":8,"Activity":0.0275,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":8,"Activity":0.025,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":9,"Activity":0.03,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":9,"Activity":0.0275,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":9,"Activity":0.025,"Age":1,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":9,"Activity":0.03,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":9,"Activity":0.0275,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":9,"Activity":0.025,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":9,"Activity":0.03,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":9,"Activity":0.0275,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":9,"Activity":0.025,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.501,"Kilo 2 months":7.02},{"Weight":10,"Activity":0.03,"Age":1,"Grams per day":275,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":10,"Activity":0.0275,"Age":1,"Grams per day":275,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":10,"Activity":0.025,"Age":1,"Grams per day":275,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":10,"Activity":0.03,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":10,"Activity":0.0275,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":10,"Activity":0.025,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":10,"Activity":0.03,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":10,"Activity":0.0275,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.502,"Kilo per month":7.01,"Kilo 2 months":14.01},{"Weight":10,"Activity":0.025,"Age":0.5,"Grams per day":125,"Kilo 2 weeks":1.7501,"Kilo per month":3.75,"Kilo 2 months":7.5},{"Weight":11,"Activity":0.03,"Age":1,"Grams per day":325,"Kilo 2 weeks":3.509,"Kilo per month":7.002,"Kilo 2 months":14.002},{"Weight":11,"Activity":0.0275,"Age":1,"Grams per day":325,"Kilo 2 weeks":3.509,"Kilo per month":7.002,"Kilo 2 months":14.002},{"Weight":11,"Activity":0.025,"Age":1,"Grams per day":325,"Kilo 2 weeks":3.509,"Kilo per month":7.002,"Kilo 2 months":14.002},{"Weight":11,"Activity":0.03,"Age":0.75,"Grams per day":325,"Kilo 2 weeks":3.509,"Kilo per month":7.002,"Kilo 2 months":14.002},{"Weight":11,"Activity":0.0275,"Age":0.75,"Grams per day":325,"Kilo 2 weeks":3.509,"Kilo per month":7.002,"Kilo 2 months":14.002},{"Weight":11,"Activity":0.025,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.503,"Kilo per month":7.03,"Kilo 2 months":14.02},{"Weight":11,"Activity":0.03,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.503,"Kilo per month":7.03,"Kilo 2 months":14.02},{"Weight":11,"Activity":0.0275,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.503,"Kilo per month":7.03,"Kilo 2 months":14.02},{"Weight":11,"Activity":0.025,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.503,"Kilo per month":7.03,"Kilo 2 months":14.02},{"Weight":12,"Activity":0.03,"Age":1,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":12,"Activity":0.0275,"Age":1,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":12,"Activity":0.025,"Age":1,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":12,"Activity":0.03,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.504,"Kilo per month":7.04,"Kilo 2 months":14.03},{"Weight":12,"Activity":0.0275,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.504,"Kilo per month":7.04,"Kilo 2 months":14.03},{"Weight":12,"Activity":0.025,"Age":0.75,"Grams per day":250,"Kilo 2 weeks":3.504,"Kilo per month":7.04,"Kilo 2 months":14.03},{"Weight":12,"Activity":0.03,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.504,"Kilo per month":7.04,"Kilo 2 months":14.03},{"Weight":12,"Activity":0.0275,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.504,"Kilo per month":7.04,"Kilo 2 months":14.03},{"Weight":12,"Activity":0.025,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.504,"Kilo per month":7.04,"Kilo 2 months":14.03},{"Weight":13,"Activity":0.03,"Age":1,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":13,"Activity":0.0275,"Age":1,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":13,"Activity":0.025,"Age":1,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":13,"Activity":0.03,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":13,"Activity":0.0275,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":13,"Activity":0.025,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":5.25,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":13,"Activity":0.03,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.505,"Kilo per month":7.05,"Kilo 2 months":14.04},{"Weight":13,"Activity":0.0275,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.505,"Kilo per month":7.05,"Kilo 2 months":14.04},{"Weight":13,"Activity":0.025,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.505,"Kilo per month":7.05,"Kilo 2 months":14.04},{"Weight":14,"Activity":0.03,"Age":1,"Grams per day":375,"Kilo 2 weeks":3.505,"Kilo per month":10.5,"Kilo 2 months":19.6},{"Weight":14,"Activity":0.0275,"Age":1,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":14,"Activity":0.025,"Age":1,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":14,"Activity":0.03,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":14,"Activity":0.0275,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":14,"Activity":0.025,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":14,"Activity":0.03,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.505,"Kilo per month":7.05,"Kilo 2 months":14.04},{"Weight":14,"Activity":0.0275,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.505,"Kilo per month":7.05,"Kilo 2 months":14.04},{"Weight":14,"Activity":0.025,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.505,"Kilo per month":7.05,"Kilo 2 months":14.04},{"Weight":15,"Activity":0.03,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14,"Kilo 2 months":28},{"Weight":15,"Activity":0.0275,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14,"Kilo 2 months":28},{"Weight":15,"Activity":0.025,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14,"Kilo 2 months":28},{"Weight":15,"Activity":0.03,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":15,"Activity":0.0275,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":15,"Activity":0.025,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":15,"Activity":0.03,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.505,"Kilo per month":7.05,"Kilo 2 months":14.04},{"Weight":15,"Activity":0.0275,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.505,"Kilo per month":7.05,"Kilo 2 months":14.04},{"Weight":15,"Activity":0.025,"Age":0.5,"Grams per day":250,"Kilo 2 weeks":3.505,"Kilo per month":7.05,"Kilo 2 months":14.04},{"Weight":16,"Activity":0.03,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":16,"Activity":0.0275,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":16,"Activity":0.025,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":16,"Activity":0.03,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":16,"Activity":0.0275,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":16,"Activity":0.025,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":16,"Activity":0.03,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":16,"Activity":0.0275,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":16,"Activity":0.025,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":4.9,"Kilo per month":9.8,"Kilo 2 months":19.6},{"Weight":17,"Activity":0.03,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":17,"Activity":0.0275,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":17,"Activity":0.025,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":17,"Activity":0.03,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":17,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":17,"Activity":0.025,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":17,"Activity":0.03,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.5,"Kilo per month":10.5,"Kilo 2 months":21},{"Weight":17,"Activity":0.0275,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.5,"Kilo per month":10.5,"Kilo 2 months":21},{"Weight":17,"Activity":0.025,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.5,"Kilo per month":10.5,"Kilo 2 months":21},{"Weight":18,"Activity":0.03,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":18,"Activity":0.0275,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":18,"Activity":0.025,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":18,"Activity":0.03,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":18,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":18,"Activity":0.025,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":5.5,"Kilo per month":10.5,"Kilo 2 months":21},{"Weight":18,"Activity":0.03,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.5,"Kilo per month":10.5,"Kilo 2 months":21},{"Weight":18,"Activity":0.0275,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.5,"Kilo per month":10.5,"Kilo 2 months":21},{"Weight":18,"Activity":0.025,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.5,"Kilo per month":10.5,"Kilo 2 months":21},{"Weight":19,"Activity":0.03,"Age":1,"Grams per day":625,"Kilo 2 weeks":7.06,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":19,"Activity":0.0275,"Age":1,"Grams per day":625,"Kilo 2 weeks":7.06,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":19,"Activity":0.025,"Age":1,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":19,"Activity":0.03,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":19,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":19,"Activity":0.025,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.06,"Kilo per month":14.05,"Kilo 2 months":28},{"Weight":19,"Activity":0.03,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":4.55,"Kilo per month":9,"Kilo 2 months":18},{"Weight":19,"Activity":0.0275,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":4.55,"Kilo per month":9,"Kilo 2 months":18},{"Weight":19,"Activity":0.025,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":4.55,"Kilo per month":9,"Kilo 2 months":18},{"Weight":20,"Activity":0.03,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":20,"Activity":0.0275,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":20,"Activity":0.025,"Age":1,"Grams per day":500,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":20,"Activity":0.03,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":20,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":20,"Activity":0.025,"Age":0.75,"Grams per day":375,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":20,"Activity":0.03,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":7.08,"Kilo per month":14.07,"Kilo 2 months":28.02},{"Weight":20,"Activity":0.0275,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":7.08,"Kilo per month":14.07,"Kilo 2 months":28.02},{"Weight":20,"Activity":0.025,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":7.08,"Kilo per month":14.07,"Kilo 2 months":28.02},{"Weight":21,"Activity":0.03,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":21,"Activity":0.0275,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":21,"Activity":0.025,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":21,"Activity":0.03,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":21,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":21,"Activity":0.025,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":21,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.08,"Kilo per month":14.07,"Kilo 2 months":28.02},{"Weight":21,"Activity":0.0275,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":7.08,"Kilo per month":14.07,"Kilo 2 months":28.02},{"Weight":21,"Activity":0.025,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":7.08,"Kilo per month":14.07,"Kilo 2 months":28.02},{"Weight":22,"Activity":0.03,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":22,"Activity":0.0275,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":22,"Activity":0.025,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":22,"Activity":0.03,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":22,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":22,"Activity":0.025,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":22,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.08,"Kilo per month":14.07,"Kilo 2 months":28.02},{"Weight":22,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.08,"Kilo per month":14.07,"Kilo 2 months":28.02},{"Weight":22,"Activity":0.025,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":7.08,"Kilo per month":14.07,"Kilo 2 months":28.02},{"Weight":23,"Activity":0.03,"Age":1,"Grams per day":500,"Kilo 2 weeks":8.75,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":23,"Activity":0.025,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":4.55,"Kilo per month":9.1,"Kilo 2 months":18.2},{"Weight":23,"Activity":0.0275,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":4.55,"Kilo per month":9.1,"Kilo 2 months":18.2},{"Weight":23,"Activity":0.03,"Age":0.5,"Grams per day":325,"Kilo 2 weeks":4.55,"Kilo per month":9.1,"Kilo 2 months":18.2},{"Weight":23,"Activity":0.025,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":23,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":23,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":23,"Activity":0.025,"Age":1,"Grams per day":500,"Kilo 2 weeks":8.75,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":23,"Activity":0.0275,"Age":1,"Grams per day":500,"Kilo 2 weeks":8.75,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":24,"Activity":0.025,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":24,"Activity":0.0275,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":24,"Activity":0.03,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":24,"Activity":0.025,"Age":0.75,"Grams per day":450,"Kilo 2 weeks":6.3,"Kilo per month":12.6,"Kilo 2 months":25.2},{"Weight":24,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":24,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":24,"Activity":0.025,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":24,"Activity":0.0275,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":24,"Activity":0.03,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":25,"Activity":0.025,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":25,"Activity":0.0275,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":25,"Activity":0.03,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":25,"Activity":0.025,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":25,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":25,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":25,"Activity":0.025,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":25,"Activity":0.0275,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":25,"Activity":0.03,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":26,"Activity":0.025,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":26,"Activity":0.0275,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":26,"Activity":0.03,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":26,"Activity":0.025,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":26,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":26,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":26,"Activity":0.025,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":26,"Activity":0.0275,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":26,"Activity":0.03,"Age":1,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":27,"Activity":0.025,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":27,"Activity":0.0275,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":27,"Activity":0.03,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":9.801,"Kilo 2 months":21.01},{"Weight":27,"Activity":0.025,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":27,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":27,"Activity":0.0275,"Age":0.75,"Grams per day":500,"Kilo 2 weeks":7.07,"Kilo per month":14.06,"Kilo 2 months":28.01},{"Weight":27,"Activity":0.025,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.502,"Kilo per month":21.02,"Kilo 2 months":42},{"Weight":27,"Activity":0.0275,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.502,"Kilo per month":21.02,"Kilo 2 months":42},{"Weight":27,"Activity":0.03,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.502,"Kilo per month":21.02,"Kilo 2 months":42},{"Weight":28,"Activity":0.025,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":10.501,"Kilo 2 months":21.01},{"Weight":28,"Activity":0.0275,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":10.501,"Kilo 2 months":21.01},{"Weight":28,"Activity":0.03,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":10.501,"Kilo 2 months":21.01},{"Weight":28,"Activity":0.025,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":28,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":28,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":28,"Activity":0.025,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.502,"Kilo per month":21.02,"Kilo 2 months":42},{"Weight":28,"Activity":0.0275,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.502,"Kilo per month":21.02,"Kilo 2 months":42},{"Weight":28,"Activity":0.03,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.502,"Kilo per month":21.02,"Kilo 2 months":42},{"Weight":29,"Activity":0.025,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":10.501,"Kilo 2 months":21.01},{"Weight":29,"Activity":0.0275,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":10.501,"Kilo 2 months":21.01},{"Weight":29,"Activity":0.03,"Age":0.5,"Grams per day":375,"Kilo 2 weeks":5.259,"Kilo per month":10.501,"Kilo 2 months":21.01},{"Weight":29,"Activity":0.025,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":29,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":29,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.75,"Kilo per month":17.5,"Kilo 2 months":35},{"Weight":29,"Activity":0.025,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.502,"Kilo per month":21.02,"Kilo 2 months":42},{"Weight":29,"Activity":0.0275,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.502,"Kilo per month":21.02,"Kilo 2 months":42},{"Weight":29,"Activity":0.03,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.502,"Kilo per month":21.02,"Kilo 2 months":42},{"Weight":30,"Activity":0.025,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14,"Kilo 2 months":28.001},{"Weight":30,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14,"Kilo 2 months":28.001},{"Weight":30,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14,"Kilo 2 months":28.001},{"Weight":30,"Activity":0.025,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":30,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":30,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":30,"Activity":0.025,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.509,"Kilo per month":21.009,"Kilo 2 months":42.001},{"Weight":30,"Activity":0.0275,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.509,"Kilo per month":21.009,"Kilo 2 months":42.001},{"Weight":30,"Activity":0.03,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.509,"Kilo per month":21.009,"Kilo 2 months":42.001},{"Weight":31,"Activity":0.025,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14,"Kilo 2 months":28.001},{"Weight":31,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14,"Kilo 2 months":28.001},{"Weight":31,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14,"Kilo 2 months":28.001},{"Weight":31,"Activity":0.025,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.5,"Kilo 2 months":35.009},{"Weight":31,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.5,"Kilo 2 months":35.009},{"Weight":31,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.5,"Kilo 2 months":35.009},{"Weight":31,"Activity":0.025,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.509,"Kilo per month":21.009,"Kilo 2 months":42.001},{"Weight":31,"Activity":0.0275,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.509,"Kilo per month":21.009,"Kilo 2 months":42.001},{"Weight":31,"Activity":0.03,"Age":1,"Grams per day":750,"Kilo 2 weeks":10.509,"Kilo per month":21.009,"Kilo 2 months":42.001},{"Weight":32,"Activity":0.025,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":32,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":32,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":32,"Activity":0.025,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":32,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":32,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":32,"Activity":0.025,"Age":1,"Grams per day":825,"Kilo 2 weeks":11.555,"Kilo per month":23.111,"Kilo 2 months":46.209},{"Weight":32,"Activity":0.0275,"Age":1,"Grams per day":825,"Kilo 2 weeks":11.555,"Kilo per month":23.111,"Kilo 2 months":46.209},{"Weight":32,"Activity":0.03,"Age":1,"Grams per day":825,"Kilo 2 weeks":11.555,"Kilo per month":23.111,"Kilo 2 months":46.209},{"Weight":33,"Activity":0.025,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":33,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":33,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":33,"Activity":0.025,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":33,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":33,"Activity":0.0275,"Age":0.75,"Grams per day":625,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":33,"Activity":0.025,"Age":1,"Grams per day":825,"Kilo 2 weeks":11.555,"Kilo per month":23.111,"Kilo 2 months":46.209},{"Weight":33,"Activity":0.0275,"Age":1,"Grams per day":825,"Kilo 2 weeks":11.555,"Kilo per month":23.111,"Kilo 2 months":46.209},{"Weight":33,"Activity":0.03,"Age":1,"Grams per day":825,"Kilo 2 weeks":11.555,"Kilo per month":23.111,"Kilo 2 months":46.209},{"Weight":34,"Activity":0.025,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":34,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":34,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":34,"Activity":0.025,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":34,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":34,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":34,"Activity":0.025,"Age":1,"Grams per day":825,"Kilo 2 weeks":11.555,"Kilo per month":23.111,"Kilo 2 months":46.209},{"Weight":34,"Activity":0.0275,"Age":1,"Grams per day":825,"Kilo 2 weeks":11.555,"Kilo per month":23.111,"Kilo 2 months":46.209},{"Weight":34,"Activity":0.03,"Age":1,"Grams per day":825,"Kilo 2 weeks":11.555,"Kilo per month":23.111,"Kilo 2 months":46.209},{"Weight":35,"Activity":0.025,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":35,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":35,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":35,"Activity":0.025,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":35,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":35,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":35,"Activity":0.025,"Age":1,"Grams per day":875,"Kilo 2 weeks":12,"Kilo per month":24.5,"Kilo 2 months":49},{"Weight":35,"Activity":0.0275,"Age":1,"Grams per day":875,"Kilo 2 weeks":12,"Kilo per month":24.5,"Kilo 2 months":49},{"Weight":35,"Activity":0.03,"Age":1,"Grams per day":875,"Kilo 2 weeks":12,"Kilo per month":24.5,"Kilo 2 months":49},{"Weight":36,"Activity":0.025,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":36,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":36,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":36,"Activity":0.025,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":36,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":36,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":36,"Activity":0.025,"Age":1,"Grams per day":875,"Kilo 2 weeks":12,"Kilo per month":24.5,"Kilo 2 months":49},{"Weight":36,"Activity":0.0275,"Age":1,"Grams per day":875,"Kilo 2 weeks":12,"Kilo per month":24.5,"Kilo 2 months":49},{"Weight":36,"Activity":0.03,"Age":1,"Grams per day":875,"Kilo 2 weeks":12,"Kilo per month":24.5,"Kilo 2 months":49},{"Weight":37,"Activity":0.025,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":37,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":37,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":37,"Activity":0.025,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":37,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":37,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":37,"Activity":0.025,"Age":1,"Grams per day":925,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":37,"Activity":0.0275,"Age":1,"Grams per day":925,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":37,"Activity":0.03,"Age":1,"Grams per day":925,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":38,"Activity":0.025,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":38,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":38,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":38,"Activity":0.025,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":38,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":38,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":38,"Activity":0.025,"Age":1,"Grams per day":925,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":38,"Activity":0.0275,"Age":1,"Grams per day":925,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":38,"Activity":0.03,"Age":1,"Grams per day":925,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":39,"Activity":0.025,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":39,"Activity":0.0275,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":39,"Activity":0.03,"Age":0.5,"Grams per day":500,"Kilo 2 weeks":7.001,"Kilo per month":14.001,"Kilo 2 months":28.001},{"Weight":39,"Activity":0.025,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":39,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":39,"Activity":0.0275,"Age":0.75,"Grams per day":750,"Kilo 2 weeks":8.5,"Kilo per month":17.509,"Kilo 2 months":35.009},{"Weight":39,"Activity":0.025,"Age":1,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":39,"Activity":0.0275,"Age":1,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":39,"Activity":0.03,"Age":1,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":40,"Activity":0.03,"Age":1,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":40,"Activity":0.025,"Age":0.075,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":40,"Activity":0.0275,"Age":0.5,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":41,"Activity":0.03,"Age":1,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":41,"Activity":0.025,"Age":0.075,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":41,"Activity":0.0275,"Age":0.5,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":42,"Activity":0.03,"Age":1,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":42,"Activity":0.025,"Age":0.075,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":42,"Activity":0.0275,"Age":0.5,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":43,"Activity":0.03,"Age":1,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":43,"Activity":0.025,"Age":0.075,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":43,"Activity":0.0275,"Age":0.5,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":44,"Activity":0.03,"Age":1,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":44,"Activity":0.025,"Age":0.075,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":44,"Activity":0.0275,"Age":0.5,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":45,"Activity":0.03,"Age":1,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":45,"Activity":0.025,"Age":0.075,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":45,"Activity":0.0275,"Age":0.5,"Grams per day":1000,"Kilo 2 weeks":13,"Kilo per month":26,"Kilo 2 months":52},{"Weight":null,"Activity":null,"Age":null,"Grams per day":null,"Kilo 2 weeks":null,"Kilo per month":null,"Kilo 2 months":null},{"Weight":null,"Activity":null,"Age":null,"Grams per day":null,"Kilo 2 weeks":null,"Kilo per month":null,"Kilo 2 months":null}]
    
    const calculator = {
    init () {
      window.calculatorApp = this;
      this.container = document.querySelector('.feeding_calculator_sec');
      if (!this.container) return;
      this.model = null;
      this.resultViews = {
         intro: this.container.querySelector('.results__intro'),
         final: this.container.querySelector('.results__final')
      }
      this.buttons = {
        submit: this.container.querySelector('.feeding-calculator__submit'),
        reset: this.container.querySelector('.feeding-calculator__reset'),
        back: this.container.querySelector('.cal_back--btn')
      }
      this.foodRecommendationsView = {
        container: document.querySelector('.featuredCollection'),
        links: this.container.querySelectorAll('.recommendation_based_pd a')
      }
      this.quizView = {
        quiz: this.container.querySelector('.feeding-calculator__quiz'),
        form: this.container.querySelector('form'),
        selects: this.container.querySelectorAll('.feeding-calculator__select select')
      }
      this.setupEvents();
    },
  
    setupEvents() {
      this.quizView.form.onsubmit = this.handleFormSubmit.bind(this);
      this.quizView.selects.forEach(select => select.onchange = this.handleSelectChange.bind(this));
      this.foodRecommendationsView.container.querySelectorAll('.productItem__content').forEach(recommendation => recommendation.onclick = this.handeleRecommedationClick.bind(this));
      this.foodRecommendationsView.links.forEach(link => link.onclick = this.handleRecommendedProductsLinkClick.bind(this));
      this.buttons.reset.onclick = this.handleResetClick.bind(this);
      this.buttons.back.onclick = this.handleBackButtonClick.bind(this);
    },

    reset() {
      this.model = {
        formData: null,
        result: null
      }
    },

    convertAge(age) {
      if (age < 5) {
        return 1;
      }
      if (age < 10) {
        return 0.75;
      }
      if (age >= 10) {
        return 0.5 
      }
    },

    calculate() {
      const { weight, age, activity } = this.model.formData;
      const formulaAge = this.convertAge(age);
      const result = FORMULA.find(item => (
        item.Weight === weight && item.Activity === activity && item.Age === formulaAge
      ));
      return result;
      
    },

    activateSelectionDiv(select) {
      const selectionDiv = select.closest('.feeding-calculator__selection');
      select.value ? selectionDiv.classList.add('active') : selectionDiv.classList.remove('active');
    },

    hideView(view) {
      view.classList.add('conceal');
    },

    showView(view) {
      view.classList.remove('conceal');
    },

    validateForm(data) {
      const keys = Object.keys(data).filter(x => !data[x]);
      return !keys.length;
    },
  
    handleSelectChange(e) {
      const select = e.target;
      this.activateSelectionDiv(select);
    },

    handeleRecommedationClick(e) {
      e.preventDefault();
      localStorage.setItem('calculator-info', JSON.stringify(this.model.formData));
      window.location.href = e.currentTarget.href;
    },

    handleRecommendedProductsLinkClick(e) {
      e.preventDefault();
      scrollToTargetAdjusted(this.foodRecommendationsView.container, document.querySelector('.header').clientHeight)
    },

    handleResetClick() {
      this.reset();
      this.render();
    },

    handleFormSubmit(e) {
      e.preventDefault();
      const isMobile = window.screen.width <= 610;
      // alert(JSON.stringify({ isMobile, width: window.innerWidth}));

      const formData = Array.from(this.quizView.selects).reduce((acc, select) => {
        if (select.name){
          acc[select.name] = +select.value;
        }
        return acc;
      }, {});
      const selectedAge = formData.age;
      const resultbox = document.querySelector(".results__final-contact-cta");
      const otherResults  = document.querySelector(".results__final-recommendation");
      if(selectedAge <= "1"){
        resultbox.style.display = "block";
        otherResults.style.display = "none";
      }
      else{
         resultbox.style.display = "none";
         otherResults.style.display = "block";
      }
      const valid = this.validateForm(formData);

      if (!valid) return;

      this.model = { formData };
      this.model.result = this.calculate()['Grams per day'];
      localStorage.setItem('calculator-info', JSON.stringify(formData));
      this.render();
      
    },

    handleBackButtonClick() {
      this.reset();
      this.render();
    },

    renderContainer() {
      if(this.model.result){
        this.container.classList.add('active');
      } else {
        this.container.classList.remove('active');
      }
    },

    renderBtnsView() {
      if(this.model.result){
        this.buttons.reset.classList.remove('hidden');
      } else {
        this.buttons.reset.classList.add('hidden');
      }
    },

    renderResultView() {
      if (!this.model) return;
      
      const { intro, final } = this.resultViews;
      const gramsBoard = final.querySelector('#grams-board');
      const bagsBoard = final.querySelector('#bags-board');
      
      if (this.model.result) {
        gramsBoard.textContent = this.model.result;
        bagsBoard.textContent = Math.round((this.model.result / BAG_WEIGHT)*4) / 4 + ' x';
        this.hideView(intro);
        setTimeout(() => {
          intro.classList.add('display-none');
          this.showView(final);
        }, 500);
      } else {
        this.hideView(final);
        intro.classList.remove('display-none');
        this.showView(intro); 
        gramsBoard.textContent = '-';
        bagsBoard.textContent = '-';
      }
      
    },

    renderFoodRecommedationsView () {
      if(this.model.result) {
        this.foodRecommendationsView.container.classList.add('display-block');
      } else {
        this.foodRecommendationsView.container.classList.remove('display-block');
      }
    },

    renderQuizView() {
      const { form, quiz, selects } = this.quizView;
      const isMobile = window.screen.width <= 610;
      // alert(JSON.stringify({ isMobile, width: window.innerWidth}));
      
      if (!this.model.result) {
        form.reset();
        selects.forEach(x => x.dispatchEvent(new Event('change')));
        if (isMobile) {
          quiz.classList.remove('conceal');
          quiz.classList.remove('display-none');
        }
        return;
      };
      
     
      if (!isMobile) return;
      quiz.classList.add('conceal');
      setTimeout(() => {
        quiz.classList.add('display-none');
      }, 500);
      return;
    },

    render() {
      this.renderContainer();
      this.renderResultView(); 
      this.renderBtnsView();
      this.renderFoodRecommedationsView();
      this.renderQuizView();
    }
  }
  
  calculator.init();

  //FAQs
  $( function () {
    jQuery(".accordion_head").click(function() {
      // if (jQuery('.accordion_body').is(':visible')) {
      //   jQuery(".accordion_body").slideUp(300);
      //   jQuery(".plusminus").text('+');
      // }
      if (jQuery(this).next(".accordion_body").is(':visible')) {
        jQuery(this).next(".accordion_body").slideUp(300);
        jQuery(this).children(".plusminus").text('+');
      } else {
        jQuery(this).next(".accordion_body").slideDown(300);
        jQuery(this).children(".plusminus").text('-');
      }
    })         
  })


  const autoSelectApp = {
    init() {
      const calculatorInfoString = localStorage.getItem('calculator-info');
      this.variantSelect = document.querySelector('.productSection__variantSelect'); 
      if (!(calculatorInfoString && this.variantSelect)) return;
      this.calculatorInfo = JSON.parse(calculatorInfoString);
      this.selectOption();
    },

    selectOption() {
      const { weight, age } = this.calculatorInfo;
    
      const variants = $('.productSection__variantOption').map(function (idx, ele) {
          return {
              value: $(ele).val(),
              maxWeight: parseInt($(ele).attr('data-max-weight')),
              minWeight: parseInt($(ele).attr('data-min-weight')),
              maxAge: parseInt($(ele).attr('data-max-age')),
              minAge: parseInt($(ele).attr('data-min-age')),
          };
      }).get();
    
      variants.shift()
    
      const weightFilter = variants.filter(({ maxWeight,
          minWeight }) => {
          maxWeight = maxWeight || 200
          minWeight = minWeight || 0
  
          if (weight <= maxWeight && weight >= minWeight) {
              return true
          }
  
          return false
  
      })
  
      const selectedVariant = weightFilter.find(({
          maxAge,
          minAge }) => {
  
          maxAge = maxAge || 200
          minAge = minAge || 0
          if (age <= maxAge && age >= minAge) {
              return true
          }
  
          return false
      })
  
      let selected = weightFilter[0]?.value || "0"
  
      if (selectedVariant) {
          selected = selectedVariant.value
      }
  
      $('.productSection__form .productSection__variantSelect').each(function () {
          $(this).val(selected)
          $('.productSection__form').trigger('change')
      })

      localStorage.removeItem('calculator-info')
    }
  }

  autoSelectApp.init();
  
}());


(function feedingInstructions() {

  console.log("HERE I AM")

  const CONSTANTS = {
    FEEDING_INSTRUCTIONS_URI: 'ox0686xao9.execute-api.eu-central-1.amazonaws.com/default/boosaOrderDetailsProvider'
  }
  
  const ENUMS = {
    PRODUCT_TYPES: {
      Fresh: 'Fresh',
      Frozen: 'Frozen'
    }
  }
  
  const feedingInstructionsApp = {
    init() {
      this.container = document.querySelector('.feeding_wrap');
      if (!this.container) return;
      this.model = {
        data: null,
        loading: true,
        messages: this.container.dataset
      }
      this.setupViews();
      this.render();
      this.endpoint = `https://${CONSTANTS.FEEDING_INSTRUCTIONS_URI}`;
      const urlSearchParams = new URLSearchParams(window.location.search);
      this.orderId = urlSearchParams.get('b');
      if (!this.orderId) {
        this.activateNotFoundScreen();
        return;
      };
      this.fetchData();
    },
  
    getModel() {
      return this.model;
    },
  
    updateModel(identifier, value) {
      this.model[identifier] = value;
      this.render();
    },
  
    setupViews() {
      this.views = {
        header: {}, 
        body: {},
      };
      this.views.header.container = this.container.querySelector('.ordertxt_wrap');
      this.views.body.container = this.container.querySelector('.tabs_wrap');
      this.views.body.orders = this.container.querySelector('.tab-content');
      this.views.body.loader = this.container.querySelector("#loading_indicator");
    },
  
    async fetchData(loading = true) {
      debugger;
      if (!this.orderId && !this.orderNumber) {
        this.activateNotFoundScreen();
        return;
      }
      try {
        this.updateModel('loading', loading);
        const res = await fetch(this.endpoint + (this.orderId ? `?orderId=${this.orderId}` : `?orderNumber=${this.orderNumber}`));
        const json = await res.json();
        if (res.status === 200){
          this.updateModel('data', json);
          this.updateModel('loading', false);
          return { status: res.status, data: json }
        } else if (res.status === 404 || res.status == 500) {
          this.activateNotFoundScreen();
          return { status: res.status, error: json };
        } else {
          return { status: res.status, error: { errorMessage: "Something went wrong. Please try again later" } }
        }
      } catch(err) {
        console.error(err);
        return err;
      } 
    },
  
    showLoader() {
      const { body } = this.views;
      body.loader.classList.add('visible');
      // document.body.classList.add('unscroll');
    },
  
    hideLoader() {
      const { body } = this.views;
      // if (!body.loader.classList.contains('visible')) return;
      body.loader.classList.remove('visible');
      // document.body.classList.remove('unscroll');
    },

    activateNotFoundScreen() {
      const { messages } = this.getModel();
      this.container.querySelector('.feeding_container').innerHTML = `
        <div class="feeding__not-found-msg"><p>${messages.notFoundMessage}</p></div>
      `;
      this.hideLoader();
    },
  
    render() {
      const { loading, data } = this.getModel();
      if (loading) return this.showLoader();
      this.hideLoader();
      if (!data) return;
      this.renderHeader();
      this.renderBody();
    },
    
    renderHeader() {
      const { data: { stickersData, fulfillment_status }, messages } = this.getModel();
      const { header } = this.views;
      header.container.querySelector('.username').textContent = stickersData[0]?.parentName ?? '';
      header.container.querySelector('.order-status-message').textContent = fulfillment_status === 'fulfilled' ? messages.orderFulfilledMessage : messages.orderOnWayMessage;
    },
  
    renderBody() {
      const { PRODUCT_TYPES } = ENUMS;
      const { data: { stickersData }, loading, messages } = this.getModel();
      const { body } = this.views;
  
      const ordersContainer = body.orders.querySelector('.orders_container');
  
      const html = stickersData.map((stickerData) => {
        const productName = stickerData.productName;
        const bagPerDay = stickerData.bagPerDay ?? null;
        const productType = stickerData.productType ?? null;
        
        return `<div class="order_item">
          <div class="order_top">
            <div class="orderimg">
              <img
                src="https://cdn.shopify.com/s/files/1/0670/1439/4156/files/turkey.png"
                loading="lazy"
                width=""
                height=""
              >
            </div>
            <div class="order_data">
              <h4 class="pro_title">${productName}</h4>
              ${bagPerDay ? '<p class="order_quantity"><span class="quantity_no">' + bagPerDay + messages.perDayText : ''}
            </div>
          </div>
          <div class="order_bottom">
            <img
              class="orderdesicon"
              src="https://cdn.shopify.com/s/files/1/0670/1439/4156/files/icon_svg.svg?v=1693143774"
              loading="lazy"
              width=""
              height=""
            >
            <p class="orderdes">
              ${productType === PRODUCT_TYPES.Fresh ? messages.freshFoodMessage : messages.frozenFoodMessage}
            </p>
          </div>
        </div>`;
      }).join('');
      
      ordersContainer.innerHTML = html;
    }
  }

  window.feedingInstructionsApp = feedingInstructionsApp;

  const feedingInstructionsForm = {
    init() {
      this.container = document.querySelector('.order-number-form-wrap');
      if (!this.container) return;
      if (!window.location.href.includes('/he')) {
        this.redirectToHebrew();
      } else {
        sessionStorage.setItem('redirectedToHebrew', 'true');
      }
      this.form = this.container.querySelector('#order-number-form');
      this.errorMessageBoard = this.form.querySelector('#order-form-error-message');
      this.submitBtn = this.container.querySelector('.button--loading');
      this.feedingWrap = document.querySelector('.feeding_wrap');
      this.feedingWrapShopifySectionDiv = this.feedingWrap.parentNode;
      this.videoShopifySectionDiv = this.feedingWrapShopifySectionDiv.nextElementSibling;
      this.faqShopifySectionDiv = this.videoShopifySectionDiv.nextElementSibling;

      this.resultViews = [this.feedingWrapShopifySectionDiv, this.videoShopifySectionDiv, this.faqShopifySectionDiv];
      this.resultViews.forEach(view => view.classList.add('display-none'));
      feedingInstructionsApp.views.body.loader.classList.add('display-none');
      this.setupEventListeners();
    },

    setupEventListeners() {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));   
    },

    redirectToHebrew() {
      const redirectedToHebrew = sessionStorage.getItem('redirectedToHebrew');
      if (redirectedToHebrew === 'true') return;
      window.location.href = '/he/pages/feeding-instructions-x';
      sessionStorage.setItem('redirectedToHebrew', 'true');
    },

    focus() {
      this.form.querySelector('input').focus();
    },

    handleSubmit(e) {
     e.preventDefault();
     const orderNumberInput = this.form.querySelector('[name=order-number]');
     const orderNumber = orderNumberInput.value;

     if (!orderNumber){
       this.handleError("Please fill in your order number");
       this.focus();
       return;
     }
     this.fetchOrderDetails({
       orderNumber
     });

    },

    async fetchOrderDetails(data) {
      this.submitBtn.querySelector('.loading-spinner').classList.remove('display-none');
      this.submitBtn.querySelector('span:not(.loading-spinner)').classList.add('invisible');
      const { orderNumber } = data;
      feedingInstructionsApp.orderNumber = orderNumber;
      const res = await feedingInstructionsApp.fetchData(false);
      if (res.status === 200) {
        this.hideForm();
        this.resultViews.forEach(view => view.classList.remove('display-none'));
      } else {
        this.handleError(res.error.errorMessage);
      }
      this.submitBtn.querySelector('.loading-spinner').classList.add('display-none');
      this.submitBtn.querySelector('span:not(.loading-spinner)').classList.remove('invisible');
    },

    handleError(msg) {
      if (msg) 
        this.errorMessageBoard.textContent = msg; 
      else 
        this.errorMessageBoard.textContent = "Order Number cannot be found";   
      this.errorMessageBoard.classList.add('display-block');
    },

    hideForm() {
      this.container.classList.add('display-none');
    }
  }
  
  feedingInstructionsApp.init();
  feedingInstructionsForm.init();
  
})();


(function () {

  
//custom web components

class CustomPopup extends HTMLElement {
  constructor() {
    super();
    const triggerSelector = this.getAttribute('trigger-selector');
    if (triggerSelector) {
      this.trigger = document.querySelector(triggerSelector);  
      if (!this.trigger) return; 
      this.trigger.addEventListener('click', this.open.bind(this));
    }
    this.popupCloseButton = this.querySelector('.popup-close');
    this.setupEvents();
  }

  setupEvents() {
    this.popupCloseButton.addEventListener('click', this.close.bind(this));
    this.addEventListener('click', (e) => {
      if (e.target === this){
        this.close();
      }
    })
  }

  open(e) {
    this.classList.add('open');
    document.body.classList.add('unscroll');
    if (e) {
      console.log({
        target: e.target,
        currentTarget: e.currentTarget
      })
      this.triggerData = e.target.dataset;
    }
    if (this.onOpen) {
      this.onOpen();
    }
  }

  close(e) {
    if (e) e.preventDefault();
    this.classList.remove('open');
    document.body.classList.remove('unscroll');
    if (this.onClose) {
      this.onClose();
    }
  }
}

// class MealPlanSelector extends HTMLElement {
//     constructor() {
//       super();
//       this.checkbox = this.querySelector('input[type="checkbox"]');  
//       this.mealPlanInfo = this.querySelector('.meal-plan__info');
//       this.model = {
//         variant: null,
//         active: false,
//         product: {
//           id: this.dataset.productId,
//           title: this.dataset.productTitle
//         }
//       };
//       this.getVariantData();
//       this.model.variant = this.variantData[0];
//       this.setupEvents();
//     }

//     getVariantData() {
//       this.variantData =
//           this.variantData ||
//           JSON.parse(this.querySelector('[type="application/json"]').textContent);
//       return this.variantData;
//   	}

//     setupEvents() {
//       this.checkbox.addEventListener('change', this.onChange.bind(this));
//     }

//     onChange() {
//       this.toggle();
//     }

//     activate() {
//      this.model.active = true; 
//      this.dispatchEvent(new Event('change'));
//      this.render();
//     }

//     deactivate() {
//      this.model.active = false;  
//      this.dispatchEvent(new Event('change'));
//      this.render(); 
//     }

//     toggle() {
//       if (this.model.active) {
//         this.deactivate();
//       } else {
//         this.activate();
//       }
//     }

//     render() {
//       const { active } = this.model;
//       this.checkbox.checked = active;
//       if (active){
//         this.classList.add('active');
//         this.mealPlanInfo.textContent = 'Added';
//       } else {
//         this.classList.remove('active');
//         this.mealPlanInfo.textContent = 'Not Added';
//       }
//     }
  
// }


// class MealPlanPopup extends CustomPopup {
//   constructor() {
//     super();
//     this.form = this.querySelector('form');
//     this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
//     this.mealPlanSelectors = [...this.querySelectorAll('meal-plan-selector')];
//     this.model = {
//       subscription: null,
//     }
//   }

//   async handleFormSubmit(e) {
//     e.preventDefault();
//     this.showLoader();
//     const selectedPlansData = this.mealPlanSelectors.map(y => y.model);
//     if (this.onSubmit){
//       await this.onSubmit(selectedPlansData);
//     }
//     this.hideLoader();
//     this.close();
//   }

//   open() {
//       this.classList.add('open');
//       document.body.classList.remove('unscroll');
//       if (this.onOpen){
//         this.onOpen();
//         this.render();
//       }
//     }

//   onSubmit(data) {
//     console.log({ data })
//   }

//   showLoader() {
//     this.setAttribute('loading', '');
//   }

//   hideLoader() {
//     this.removeAttribute('loading');
//   }

//   render() {
//     this.mealPlanSelectors.forEach(x => {
//       if (this.model.subscription.items.find(y => {return y.product_id == x.dataset.productId})) {
//         x.activate();
//       }
//     })
//   }
// }


class AddProductsPopup extends CustomPopup {
  constructor() {
    super();
    this.model = {
      cart: {
        items: []
      },
      subscription: null
    }
    this.orderCartDiv = this.querySelector('.order__total-row');
    this.orderCountBoard = this.querySelector('.order-count-board');
    this.closeBtn = this.querySelector('.popup-close');
    this.closeIconSvg = this.closeBtn.innerHTML;
    this.collectionDivs = this.querySelectorAll('.product-list-wrap');
    this.setupEventListeners();
  }

  // connectedCallback() {
  //   setTimeout(() => {
  //     $('.product-list').slick({ slidesToShow: 4 });
  //   }, 2000)
  // }

  setupEventListeners() {
   this.querySelector('.popup__content').addEventListener('click', this.handleClick.bind(this));
   // this.querySelector('button[type=submit]').addEventListener('click', this.handleSubmitClick.bind(this));
   this.querySelector('.popup__content').addEventListener('change', this.handleChange.bind(this));
  }

  handleClick(e) {
    if (!e.target.matches('button') && !e.target.closest('button')) return;
    const btn = e.target.matches('button') ? e.target : e.target.closest('button');
    let itemDiv = btn.closest('.orderItem');
    switch (btn.dataset.purpose){
      case 'add': 
        itemDiv = btn.closest('.productItem');
        this.handleAdd(itemDiv);
        break;
      case 'remove': 
        itemDiv = btn.closest('.orderItem');
        this.handleRemove(itemDiv.dataset.variantId); 
        break;
      case 'change-collection':
        btn.classList.add('active');
        this.activateTab(btn.dataset.tabHandle);
        break;
      case 'submit':
        this.handleSubmit();
        break;
    }
  }

  handleChange(e) {
    if (!e.target.matches('input')) return;
    const input = e.target;
    const type = input.dataset.type;
    if (type ===  'quantity') {
      this.handleItemQuantityChange(input);
    }
  }

  handleAdd(itemDiv) {
    const variantsData = JSON.parse(itemDiv.querySelector('[type="application/json"]').innerHTML);
    console.log({ variantsData });
    const data = itemDiv.dataset;
    const { productImageUrl, productTitle, productId, sealId } = data;

    let { variantId, variantSku, variantPrice } = data;

    const selectedWeight = this.querySelector('.select-weight-wrap select').value;
    const variantToAdd = variantsData.find(variant => variant.option2?.includes('Monthly Subscription') && variant.option1 === selectedWeight);

    let variantName = null;
    if (variantToAdd) {
      variantId = variantToAdd.id;
      variantSku = variantToAdd.sku;
      variantPrice = variantToAdd.price;
      variantName = variantToAdd.name;
    }
    
    const alreadyInCart = !!this.model.cart.items.find(item => item.variantId === variantId);

    if(alreadyInCart) return;
    
    this.model.cart.items.push({
      sealId,
      productImageUrl, 
      productTitle, 
      productId: Number(productId), 
      variantId: Number(variantId), 
      quantity: Number(1),
      variantSku, 
      variantPrice: Number(variantPrice),
      variantName
    });
    
    this.render();
  }

  handleRemove(variantId) {
    const { items } = this.model.cart;
    const index = items.findIndex(x => x.variantId === Number(variantId));
    if (!(index > -1)) return;
    items.splice(index, 1);
    this.render();
  }

  handleItemQuantityChange(input) {
    const productItemDiv = input.closest('.orderItem');
    const variantId = productItemDiv.dataset.variantId;
    this.updateQuantityInCart(Number(variantId), input.value);
  }

  async handleSubmit() {
    console.log(this.model);
    if (this.onSubmit){
      await this.onSubmit(this.model);
    }
    
    this.close();
  }

  updateQuantityInCart(variantId, quantity) {
    const item = this.model.cart.items.find(x => x.variantId === variantId);
    if (!item) return;
    item.quantity = Number(quantity);
    this.render();
  }

  activateTab(handle) {
    const tabBtns = this.querySelectorAll('.tab-button');
    const rtlElm = document.querySelector('html[dir="rtl"]');
    this.collectionDivs.forEach((div, index) => {
      if (div.dataset.tabHandle === handle) {
        tabBtns[index].classList.add('active');
        div.classList.add('visible');
        const productListDiv = div.querySelector('.product-list');
        if(!productListDiv.classList.contains('slick-slider')) {
          $(div.querySelector('.product-list')).slick({
            slidesToShow: 4,  // Show 1.5 slides at a time
            slidesToScroll: 1,  // Scroll one full slide at a time
            arrows: true,       // Show arrows for navigation
            centerMode: false,  // Disable centering, align slides to the left,
            nextArrow: '<button class="slick-next"><svg class="icon icon--chevron-right" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            prevArrow: '<button class="slick-prev"><svg class="icon icon--chevron-left" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            rtl: !!document.querySelector("html[dir='rtl']"),
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              }
            ]
          });  
        }
      } else {
        div.classList.remove('visible');
        tabBtns[index].classList.remove('active');
      }
    });
  }

  // updateCollectionView(handle) {
  //   this.collectionDivs.forEach(div => {
  //     if (div.dataset.tabHandle === handle) {
  //       div.classList.add('visible');
  //       const productListDiv = div.querySelector('.product-list');
  //       if(!productListDiv.classList.contains('slick-slider')) {
  //         $(div.querySelector('.product-list')).slick({ slidesToShow: 4 });  
  //       }
  //     } else {
  //       div.classList.remove('visible');  
  //     }
  //   });
  // }

  reset() {
    this.model = {
      cart: {
        items: []
      },
      subscription: null
    }
    this.render();
  }

  onClose() {
    this.reset();
  }

  renderGlobalWeight() {
    const { items } = this.model.cart;
    console.log({ items });
  }

  render() {
    
    const { MEAL_PLAN_IDS } = CONSTANT;
    const { currencify } = helpers;
    const { delivery_interval } = this.model.subscription;
    const { items } = this.model.cart;
    
    const mealPlanItems = items.filter(item => MEAL_PLAN_IDS.includes(item.productId));

    const sortedItems = items.sort((a, b) => {
      const productIdA = a.productId;
      const productIdB = b.productId;

      const isAMealItem = MEAL_PLAN_IDS.includes(productIdA);
      const isBMealItem = MEAL_PLAN_IDS.includes(productIdB);

      if (isAMealItem && !isBMealItem) {
        return -1; // a remains winner
      } else if (!isAMealItem && isBMealItem){
        return 1; // b wins
      } else {
        return 0; // nothing changes
      }
    });
    
    const { subscription } = this.model;  

    const submitButton = this.querySelector(".order__total-wrap .btn-wrap");
    const submitButtonHTML = submitButton.outerHTML;
    
    this.orderCartDiv.innerHTML = `<div class="order__total-products">
            ${sortedItems.map(({ productId, productImageUrl, productTitle, variantId, quantity = 1, variantPrice, variantName }) => (
              `<div class="orderItem" data-variant-id="${variantId}">
              
               <button class="orderItem__remove-item-button" data-purpose="remove">${this.closeIconSvg}</button>
                
                <div class="orderItem__imageWrapper">
                  <img alt="${productTitle}" class=" orderItem__image" src="${productImageUrl}">
                </div>
                <div class="orderItem__info">
                  <div class="orderItem__qty-wrap">
                    <quantity-controller class="quantity-controller">
                      <button class="quantity__button" name="minus" type="button">
                        <span class="visually-hidden">Decrease quantity for ${productTitle}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
                          </path>
                        </svg>
                      </button>
                      <input class="quantity__input" data-type="quantity" data-quantity-variant-id="${variantId}" type="number" name="updates[]" value="${quantity}" min="1" data-min="1" step="1" aria-label="Quantity for ${productTitle}" id="Quantity-1" data-index="1">
                      <button class="quantity__button" name="plus" type="button">
                        <span class="visually-hidden">Increase quantity for ${productTitle}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
                          </path>
                        </svg>
                      </button>
                    </quantity-controller>
                  </div>
                  <h4 class="orderItem__title">
                    ${variantName?.split('/')[0] || productTitle}
                  </h4>
                  <div class="orderItem__priceWrapper">
                    <p class="orderItem__price">${currencify(variantPrice / 100)}</p> 
                  </div>
                </div>
              </div>`
            )).join('')}
          </div>
          <div class="subscription__price">
            <p>${STORE.locales.subscriptions.add_products_portal.subscription_price_text}</p> 
            <span class="subscription-price-board">${currencify(items.reduce((acc, item) => acc + parseInt(item.variantPrice), 0) / 100)}</span>
            <small>(${STORE.locales.subscriptions.add_products_portal.excluding_delivery_fee_text})</small>
            <p class="subscription__price-text"><small>${this.dataset.deliveryInfoText}</small></p>
            ${submitButtonHTML}
          </div>`;

    
    this.orderCountBoard.textContent = `(${items.length})`;

    if (delivery_interval && !this.intervalBoard) {
      const intervalSpan = document.createElement('span');
      intervalSpan.textContent = delivery_interval.replace('week', STORE.locales.subscriptions.weeks_text);
      this.querySelector('.subscription-controls-wrap').prepend(intervalSpan);
      this.intervalBoard = intervalSpan;
    } else if (delivery_interval && this.intervalBoard) {
      this.intervalBoard = delivery_interval;
    }


    // $('.order__total-products').slick({
    //   slidesToShow: 4,  // Show 1.5 slides at a time
    //   slidesToScroll: 1,  // Scroll one full slide at a time
    //   arrows: false,       // Show arrows for navigation
    //   centerMode: false,  // Disable centering, align slides to the left,
    //   nextArrow: '<button class="slick-next"><svg class="icon icon--chevron-right" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    //   prevArrow: '<button class="slick-prev"><svg class="icon icon--chevron-left" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
    // });
  }

}

class ConfirmationPopup extends CustomPopup {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.titleH3 = this.querySelector('.confirmation-popup__heading');
    this.messageP = this.querySelector('.confirmation-popup__message');
    this.continueButton = this.querySelector('#confirmation-continue-button');
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('click', this.handleClick.bind(this));
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  handleClick(e) {
    if (!e.target.matches('button[type="button"]')) return;
    this.handleCancelClick();
  }

  handleCancelClick() {
    this.close();
  }

  onOpen() {
    this.render();
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.onSubmit){
      this.onSubmit();
    }
  }

  render() {
    this.titleH3.textContent = this.triggerData.title;
    this.messageP.textContent = this.triggerData.message;
    this.continueButton.textContent = this.triggerData.continueText;
  }
}


class QuantityController extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  connectedCallback() {
    this.validateQtyRules();
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      } 
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.currentTarget.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-controller', QuantityController);


// class SubscriptionConfirmationPopup extends ConfirmationPopup {
//   constructor() {
//     super();
//   }

//   onSubmit() {
//     console.log(this.triggerData);
//   }
  
// }



customElements.define('custom-popup', CustomPopup);
// customElements.define('meal-plan-selector', MealPlanSelector);
// customElements.define('meal-plan-popup', MealPlanPopup);
customElements.define('add-products-popup', AddProductsPopup);
customElements.define('confirmation-popup', ConfirmationPopup);
// customElements.define('subscription-confirmation-popup', SubscriptionConfirmationPopup);

})();
    


(function selectSubscriptionProduct() {
  const container = document.querySelector('#product-details-section');
  if (!container) return;
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('frequency') !== 'subscription') return;

  const frequencyOptions = container.querySelector('.productSection__frequency .productSection__frequencyRadios');
  if (!frequencyOptions) return;

  const subscriptionOption = frequencyOptions.querySelector('#optionValue--2');
  
  if (subscriptionOption?.value?.includes('10%')) subscriptionOption.checked = true;
  
})();


  
      